<template>
	<div>
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="tp-parentdiv d-flex">
			<div
				class="tp-child1-div"
				:style="isEmpty || !autoTests.length ? 'width:100%;' : ''"
			>
				<div class="boxtext d-flex align-items-center justify-content-between">
					<div class="heading-container">
						<span>AutoGenerate Test</span>
					</div>
					<div class="d-flex">
						<div
							class="relativeclass mr-2 switchtext pointer test-container"
							v-closable="{
								exclude: ['testdropdown'],
								handler: 'hideTestFunction',
							}"
						>
							<div
								@click="
									(showtestcard = !showtestcard),
										(showfiltercard = false),
										(showsortcard = false)
								"
								class="auto-sortcontainer d-flex justify-content-around align-items-center"
							>
								<div class="sorttext">Test Type</div>
								<div class="sortline ml-3"></div>
								<div class="sortordertext ml-3 w-40">
									{{ testCardselected }}
								</div>
								<div class="ml-3">
									<img
										v-if="showtestcard"
										src="../../assets/uparrow.svg"
										alt=""
									/>
									<img v-else src="../../assets/downarrow.svg" alt="" />
								</div>
							</div>
							<div v-if="showtestcard" ref="testdropdown">
								<div class="tnt-sortcard-auto jdtypecard p-0 testdashboard">
									<div
										@click="showtestcard = !showtestcard"
										class="xMarkCancel pointer"
									>
										<img src="../../assets/xmark.svg" alt="" />
									</div>
									<b-form-group
										class="sec-mcq-datacard jdtyperadio"
										v-for="i in testTypeOptions"
										:key="i.value"
									>
										<b-form-radio
											class="m-1"
											size="sm"
											v-model="testCardselected"
											:value="i.text"
											@change="getTestValue(i.value)"
										>
											{{ i.text }}
										</b-form-radio>
									</b-form-group>
								</div>
							</div>
						</div>

						<div
							class="mr-2 pl-3 pr-3 relativeclass switchtext sort-box"
							:class="[
								total === 0
									? { 'not-allowed': true, 'qb-disabled': true }
									: 'pointer',
							]"
							v-closable="{
								exclude: ['sortdropdown'],
								handler: 'hideSortFunction',
							}"
						>
							<div
								@click="
									total === 0
										? null
										: ((showsortcard = !showsortcard),
										  (showfiltercard = false),
										  (showtestcard = false))
								"
							>
								Sort
								<span class="ml-3">
									<img src="../../assets/sorticon.svg" alt=""
								/></span>
							</div>
							<div v-if="showsortcard" ref="sortdropdown">
								<div
									class="tnt-sortcard p-0 d-flex align-items-center testdashboard"
								>
									<div
										class="xMarkCancel pointer z-10"
										@click="showsortcard = !showsortcard"
									>
										<img src="../../assets/xmark.svg" alt="" />
									</div>
									<b-form-group class="sec-mcq-datacard">
										<b-form-radio
											class="sort-radio"
											v-for="(sort, index) in sort_options"
											:key="index"
											v-model="sort_selected"
											@change="saveSort"
											:value="sort.value"
										>
											{{ sort.text }}
										</b-form-radio>
									</b-form-group>
								</div>
							</div>
						</div>

						<div
							class="mr-2 pr-3 relativeclass switchtext filter-box"
							:class="[
								total === 0
									? { 'not-allowed': true, 'qb-disabled': true }
									: 'pointer',
							]"
							v-closable="{
								exclude: ['filterdropdown'],
								handler: 'hideFilterFunction',
							}"
						>
							<div @click="total === 0 ? null : modalpop()" class="ml-3 d-flex">
								Filter
								<div class="ml-2 d-flex relativeclass">
									<span><img src="../../assets/filtericon.svg" alt="" /> </span>
									<div class="qb-filter-count" v-if="filtercount != 0">
										{{ filtercount }}
									</div>
								</div>
							</div>
							<div v-if="showfiltercard" ref="filterdropdown">
								<div class="tnt-filtercard d-flex align-items-center">
									<div>
										<div
											class="xMarkCancel pointer"
											@click="hideFilterFunction"
										>
											<img src="../../assets/xmark.svg" alt="" />
										</div>
										<div>
											<div class="topDiv mt-3">
												<label class="fieldsetStyle">Sections &nbsp;</label>
												<b-form-input
													class="filterinputField"
													id="input-1"
													type="number"
													min="0"
													@keypress="avoidLetterE"
													v-model="$v.filter.section.$model"
													:class="{ error: $v.filter.section.$error }"
												></b-form-input>
											</div>
										</div>

										<div class="topicfilterinnercard mt-3">
											<div class="d-flex">
												<span style="color: #545454">Public Availability </span>
												<b-form-radio-group
													class="ml-3"
													:options="options"
													v-model="filter.publicAvailability"
													value-field="item"
													text-field="name"
													disabled-field="notEnabled"
													size="sm"
												></b-form-radio-group>
											</div>
										</div>

										<div
											class="d-flex align-items-center justify-content-between mt-3"
										>
											<div
												class="clearfilter pointer mt-3"
												:class="
													filter.publicAvailability == null &&
													filter.section.toString().length == 0
														? filtercount == 0
															? 'disabled-text'
															: 'pointer'
														: 'pointer'
												"
												@click="
													filter.publicAvailability == null &&
													filter.section.toString().length == 0
														? filtercount == 0
															? clearfilterbox()
															: clearfilter()
														: filtercount == 0
														? clearfilterbox()
														: clearfilter()
												"
											>
												Clear Filter
											</div>
											<div>
												<b-button
													class="addbtn"
													:disabled="
														filter.publicAvailability == null &&
															filter.section.toString().length == 0
													"
													@click="applyfilter()"
												>
													Apply
												</b-button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="d-flex switchtext mr-3 mt-1 pointer">
							<div class="d-flex switchParent">
								<div
									v-b-popover.hover.top="'Grid View'"
									class="switchChild"
									@click="
										LoaderStatus == true ? '' : saveToggleView(),
											resetPagination()
									"
									:class="{
										activeSwitchLeft: !switchviews,
										notActiveSwitchLeft: switchviews,
									}"
								>
									<img src="../../assets/filtersorticon.svg" alt="" />
								</div>
								<div
									v-b-popover.hover.top="'List View'"
									class="switchChild"
									@click="
										LoaderStatus == true ? '' : saveToggleView(),
											resetPagination()
									"
									:class="{
										activeSwitchRight: switchviews,
										notActiveSwitchRight: !switchviews,
									}"
								>
									<img src="../../assets/rightfilterwhite.svg" alt="" />
								</div>
							</div>
						</div>
					</div>
				</div>

				<template v-if="isEmpty && !LoaderStatus">
					<div class="cl-testcontainer relativeclass mr-2" id="top1">
						<div
							class="d-flex flex-column align-items-center justify-content-center h-100"
						>
							<div>
								<img src="../../assets/searchnotfound.svg" alt="" />
							</div>
							<div
								class="text-center"
								v-if="searchTopicTest != '' && searchTopicTest != 'Loader'"
							>
								<span class="searchnotfound text-break"
									>No matching results for
									<span class="searchtext"> "{{ searchTopicTest }}" </span>
								</span>
							</div>
							<div v-else>
								<span class="searchnotfound">No data found.</span>
							</div>
						</div>
					</div>
				</template>
				<template v-else-if="!LoaderStatus">
					<div
						v-if="autoTests.length == 0 && testCardselected == 'Inactive'"
						class="cl-testcontainer relativeclass mr-2"
					>
						<div
							class="d-flex flex-column align-items-center justify-content-center h-100"
						>
							<div>
								<img src="../../assets/searchnotfound.svg" alt="" />
							</div>
							<div>
								<span class="searchnotfound">
									Currently, there are no inactive tests.
								</span>
							</div>
						</div>
					</div>
					<div
						v-else
						@scroll="onScroll"
						class="cl-testcontainer relativeclass mr-2"
						id="top1"
					>
						<div class="d-flex justify-content-end">
							<b-button
								class="addbtn"
								@click="addAutoTest()"
								v-if="
									roles.includes('PUSH_AUTO_TEST') &&
										testCardselected != 'Inactive' &&
										!showAddNewCardWhenNoData &&
										total !== 0
								"
							>
								<img src="../../assets/plusicon.svg" alt="" class="mr-2 mb-1" />
								<span class="">AutoGenerate Test</span>
							</b-button>
						</div>
						<div
							v-if="
								roles.includes('PUSH_AUTO_TEST') &&
									showAddNewCardWhenNoData &&
									testCardselected != 'Inactive' &&
									searchTopicTest == '' &&
									filtercount == 0 &&
									LoaderStatus == false
							"
						>
							<div
								class="addtopicbox d-flex justify-content-center align-items-center"
								@click="addAutoTest()"
							>
								<div class="text-center pointer">
									<img src="../../assets/addsecicon.svg" alt="" />
									<div class="addtopictext mt-2">AutoGenerate Tests</div>
								</div>
							</div>
						</div>
						<div
							class="emptycard-design h-50 d-flex align-items-center justify-content-center"
							v-if="
								roles.includes('PUSH_AUTO_TEST') &&
									showAddNewCardWhenNoData &&
									testCardselected != 'Inactive' &&
									searchTopicTest == '' &&
									filtercount == 0 &&
									LoaderStatus == false
							"
						>
							<span>To begin creating a new test</span>
							<span
								>Click on “Add new AutoGenerate Test” button, and it will appear
								here for your viewing.</span
							>
						</div>

						<template v-if="switchviews && !showAddNewCardWhenNoData">
							<div @scroll="onScroll" class="topic-cards-container mt-3">
								<transition-group name="flip-list" tag="div">
									<div
										class="tp-padng"
										v-for="(i, index) in autoTests"
										:key="i.testID"
									>
										<Autotestgrid
											@filterCard="
												(showfiltercard = false),
													(showsortcard = false),
													(showtestcard = false)
											"
											:showindex="index"
											:testDetails="i"
											:selectedTest="selectedTest"
											:type="$route.query.type"
											:sort="$route.query.sort"
											@test-card-option="testcardoptions"
											@resetPagination="resetPagination"
											@lengthofTotalTestsWhenEdited="
												lengthofTotalTestsWhenEdited
											"
										/>
									</div>
								</transition-group>
								<div
									style="margin: auto"
									v-if="showLoader"
									class="d-flex justify-content-center mb-3"
								>
									<b-spinner label="Loading..."></b-spinner>
								</div>
							</div>
						</template>
						<template v-if="!switchviews && !showAddNewCardWhenNoData">
							<div
								@scroll="onScroll"
								class="d-flex flex-wrap topic-list-card-container mt-3"
							>
								<div>
									<transition-group
										name="cell"
										class="d-flex flex-wrap"
										tag="div"
									>
										<div
											class="tp-gridpadng"
											v-for="(i, index) in autoTests"
											:key="i.testID"
										>
											<Autotestcard
												@filterCard="
													(showfiltercard = false),
														(showsortcard = false),
														(showtestcard = false)
												"
												:showindex="index"
												:testDetails="i"
												:selectedTest="selectedTest"
												:type="$route.query.type"
												:sort="$route.query.sort"
												@test-card-option="testcardoptions"
												@resetPagination="resetPagination"
												@lengthofTotalTestsWhenEdited="
													lengthofTotalTestsWhenEdited
												"
											/>
										</div>
									</transition-group>
								</div>
								<div
									style="margin: auto"
									v-if="showLoader"
									class="d-flex justify-content-center mb-3"
								>
									<b-spinner label="Loading..."></b-spinner>
								</div>
							</div>
						</template>
					</div>
				</template>
			</div>
			<div
				v-if="!isEmpty && autoTests.length"
				class="ml-2 relativeclass"
				:class="{
					tpsubchilddiv: !showTestPreviewStatus,
					tpsubchilddivppreview: showTestPreviewStatus,
				}"
			>
				<div
					v-if="!LoaderStatus"
					:class="{
						'h-100 d-flex align-items-center justify-content-center':
							!showTestPreviewStatus &&
							testConfigStatus &&
							!selectedTest.active,
					}"
				>
					<template v-if="showTestPreviewStatus">
						<TestPreview :type="'autopreview'" />
					</template>
					<template v-if="testConfigStatus && selectedTest.active">
						<AutoSideTestConfiguration />
					</template>
					<template
						v-if="
							!showTestPreviewStatus && testConfigStatus && !selectedTest.active
						"
					>
						<div>
							<img
								src="../../assets/icons/testconfig/notestconfig.svg"
								alt=""
							/>
						</div>
					</template>
					<template v-if="autoTests.length != 0">
						<div
							v-if="testConfigStatus == false && showTestPreviewStatus == false"
							class="configpreviewgraph"
						>
							<div
								class="d-flex justify-content-center align-items-center mt-5"
							>
								<img src="../../assets/icons/config.svg" alt="" />
							</div>
							<div
								class="d-flex justify-content-center align-items-center testconfig-tp-text mt-5"
							>
								OR
							</div>
							<div
								class="d-flex justify-content-center align-items-center mt-5"
							>
								<img src="../../assets/icons/test.svg" alt="" />
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
		<b-modal
			id="new-modal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			size="lg"
		>
			<div class="attempt-heading-modal">Add Autogenerate Test</div>
			<hr />
			<div @click="closenewmodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>

			<b-row>
				<b-col>
					<div class="topDiv relativeclass">
						<label class="fieldsetStyle"
							>Test Name &nbsp;<span class="asterik">*</span></label
						>
						<b-form-input
							:class="{
								error: $v.sectionData.testName.$error,
							}"
							class="inputField"
							id="input-1"
							autofocus
							type="text"
							v-model="$v.sectionData.testName.$model"
							v-on:keyup.enter="goToAutoSec()"
							placeholder="Enter here"
						></b-form-input>
						<div
							style="
                position: absolute;
                top: 4px;
                right: 12px;
                background: var(--bg-white);
              "
							v-if="
								$v.sectionData.testName.$dirty &&
									!$v.sectionData.testName.required
							"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							style="
                position: absolute;
                top: 4px;
                right: 12px;
                background: var(--bg-white);
              "
							v-if="
								!$v.sectionData.testName.maxLength &&
									$v.sectionData.testName.required
							"
							v-b-popover.hover.top.v-danger="{
								content: 'Should not exceed 128 characters',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							style="
                position: absolute;
                top: 4px;
                right: 12px;
                background: var(--bg-white);
              "
							v-if="
								!$v.sectionData.testName.alpha &&
									$v.sectionData.testName.required
							"
							v-b-popover.hover.top.v-danger="{
								content: 'Please Enter a Valid Test Name',
							}"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</b-col>
				<b-col>
					<div class="d-flex">
						<span style="color: #545454"
							>Public Availability <span class="asterik">*</span></span
						>
						<b-form-radio-group
							class="ml-3"
							:options="options"
							v-model="publicAvailability"
							value-field="item"
							text-field="name"
							disabled-field="notEnabled"
							size="sm"
						></b-form-radio-group>
					</div>
				</b-col>
			</b-row>

			<div class="d-flex align-items-center mt-3 mb-3">
				<div class="ags-checkBox">
					<b-form-checkbox
						class="mt-2 checkbox testconfig-checkbox"
						size="sm"
						name="checkbox-1"
						v-model="sectionData.autoCheck"
						@change="clearFields"
					>
						<div class="">Configure</div>
					</b-form-checkbox>
				</div>
				<div
					class="ml-2 mt-1"
					style="border: 0.5px solid #adaaaa; width: 87%"
				></div>
			</div>

			<b-row>
				<b-col cols="4">
					<div class="topDiv relativeclass">
						<label
							:class="{
								fieldsetStyle: sectionData.autoCheck,
								'disable-autofieldsetStyle': !sectionData.autoCheck,
							}"
							>No.of Sections&nbsp;<span
								v-if="sectionData.autoCheck"
								class="asterik"
								>*</span
							></label
						>
						<b-form-input
							v-on:keyup.enter="goToAutoSec()"
							:class="{
								'ags-inputField': sectionData.autoCheck,
								'ags-inactive-inputField': !sectionData.autoCheck,
								error: $v.sectionData.noofSections.$error,
							}"
							id="input-1"
							autofocus
							type="text"
							placeholder="Enter here"
							v-model="$v.sectionData.noofSections.$model"
							:disabled="!sectionData.autoCheck"
						></b-form-input>
						<div
							style="position: absolute; top: 6px; right: 12px"
							v-if="
								$v.sectionData.noofSections.$dirty &&
									!$v.sectionData.noofSections.required
							"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							style="position: absolute; top: 6px; right: 12px"
							v-if="
								!$v.sectionData.noofSections.alpha &&
									$v.sectionData.noofSections.required
							"
							v-b-popover.hover.top.v-danger="{
								content: 'Enter a valid number',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							style="position: absolute; top: 6px; right: 12px"
							v-if="
								!$v.sectionData.noofSections.between &&
									$v.sectionData.noofSections.alpha
							"
							v-b-popover.hover.top.v-danger="{
								content: 'Should be between(1 , 5)',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</b-col>
				<b-col cols="4">
					<div class="topDiv autest-parent" ref="autogenerateoptions">
						<label
							:class="{
								fieldsetStyle: sectionData.autoCheck,
								'disable-autofieldsetStyle': !sectionData.autoCheck,
							}"
							>Type of Questions<span
								v-if="sectionData.autoCheck"
								class="asterik"
								>*</span
							></label
						>
						<div
							:class="{
								'ags-dropdown-diffy': sectionData.autoCheck,
								'ags-inactive': !sectionData.autoCheck,
								error: $v.sectionData.questiontype_options.$error,
							}"
							class="d-flex justify-content-between pointer"
							@click="isChecked = !isChecked"
							v-closable="{
								exclude: ['quesdropdown'],
								handler: 'hideasnswertype',
							}"
						>
							<span v-if="sectionData.questiontype_options != 0">
								<span
									v-for="(value, index) in sectionData.questiontype_options"
									:key="index"
								>
									<span v-if="value == 'MCQU'"> MCQ</span>
									<span v-if="value == 'ALL'"> All</span>

									<span v-if="value == 'MAFO'"> MTF</span>
									<span v-if="value == 'LONG'"> Descriptive</span>

									<span
										v-if="index !== sectionData.questiontype_options.length - 1"
										>,</span
									>
								</span>
							</span>
							<span style="color: grey" v-else>Choose Options</span>

							<span
								><img src="../../assets/carrotdown.svg" alt="" class="mr-1"
							/></span>
						</div>

						<div
							class="qb-dropdown-option-add d-flex"
							v-if="isChecked == true && sectionData.autoCheck"
							ref="quesdropdown"
						>
							<b-form-group class="qb-dd-group">
								<b-form-checkbox-group
									class="agt-add-drop"
									v-model="selectedOptions"
									:options="Q_options"
									value-field="value"
									text-field="text"
									stacked
									buttons
									@change="updateOptions()"
								></b-form-checkbox-group>
							</b-form-group>
						</div>
					</div>
					<div
						class="validationicon"
						style="top: 6px; right: 43px"
						v-if="
							$v.sectionData.questiontype_options.$dirty &&
								!$v.sectionData.questiontype_options.required
						"
						v-b-popover.hover.top.v-danger="{ content: 'Required' }"
						variant="primary"
					>
						<img src="../../assets/deletepopupicon.svg" alt="" />
					</div>
				</b-col>
				<b-col cols="4">
					<div class="topDiv relativeclass">
						<label
							:class="{
								fieldsetStyle: sectionData.autoCheck,
								'disable-autofieldsetStyle': !sectionData.autoCheck,
							}"
							>Questions for each sections&nbsp;<span
								v-if="sectionData.autoCheck"
								class="asterik"
								>*</span
							></label
						>
						<b-form-input
							v-on:keyup.enter="goToAutoSec()"
							:class="{
								'ags-inputField': sectionData.autoCheck,
								'ags-inactive-inputField': !sectionData.autoCheck,
								error: $v.sectionData.autoQuestions.$error,
							}"
							id="input-1"
							autofocus
							type="text"
							placeholder="Enter here"
							:disabled="!sectionData.autoCheck"
							v-model="$v.sectionData.autoQuestions.$model"
						></b-form-input>
						<div
							style="position: absolute; top: 6px; right: 12px"
							v-if="
								$v.sectionData.autoQuestions.$dirty &&
									!$v.sectionData.autoQuestions.required
							"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							style="position: absolute; top: 6px; right: 12px"
							v-if="
								!$v.sectionData.autoQuestions.alpha &&
									$v.sectionData.autoQuestions.required
							"
							v-b-popover.hover.top.v-danger="{
								content: 'Enter a valid  number',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							style="position: absolute; top: 6px; right: 12px"
							v-if="
								!$v.sectionData.autoQuestions.between &&
									$v.sectionData.autoQuestions.alpha
							"
							v-b-popover.hover.top.v-danger="{
								content: 'Should be between 1 to 50',
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</b-col>
			</b-row>

			<div class="d-flex justify-content-end mt-4">
				<b-button class="addbtn" @click="goToAutoSec()">Generate</b-button>
			</div>
		</b-modal>
	</div>
</template>

<script>
import AutoSideTestConfiguration from "../../views/autoGenerate/AutoSideTestConfiguration.vue";
import {
	required,
	maxLength,
	helpers,
	requiredIf,
	between,
} from "vuelidate/lib/validators";
import { mapGetters, mapMutations } from "vuex";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import TestPreview from "../test/TestPreview.vue";
import Autotestgrid from "../../views/autoGenerate/autotestcards/Autotestgridview.vue";
import Autotestcard from "../../views/autoGenerate/autotestcards/Autotestcardview.vue";
import { getAutoGeneratedQusPagintion } from "../../utils/apiFunctions";

export default {
	name: "AutogenerateTest",
	data() {
		return {
			publicAvailability: false,
			name: "",
			tobeDel: "",
			selectedOptions: [],
			sortoptions_selected: "",
			sortColumn: "createdAt",
			testCardselected: "Active",
			total: 0,
			page: 0,
			count: 40,
			testnum: 1,
			optionnum: 1,
			sortorder: -1,
			card_active: -1,
			activeForTest: 1,
			pageEnd: null,
			active: false,
			showLoader: true,
			isChecked: false,
			showsortcard: false,
			editoptions: false,
			LoaderStatus: false,
			showtestcard: false,
			showfiltercard: false,
			filterModelValue: false,
			showAddNewCardWhenNoData: false,
			selectedTest: {},
			autoTests: [],
			testnames: ["Sample Test"],
			sectionData: {
				testName: "",
				noofSections: null,
				autoQuestions: null,
				questiontype_options: [],
				editSecName: false,
				autoCheck: false,
				sections: [
					{
						name: "",
						typedistributeRandomly: false,
						cardClose: false,

						addTypeDisable: false,
						typeDifficultyLevel: [],
						noOfQuestions: null,
						alldiffoptions: [],
						longdiffoptions: [],
						mcqdiffoptions: [],
						mtfdiffoptions: [],
						types: [],
						sameDifficultyLevel: false,
						typediffrequired: false,
					},
				],
			},

			filter: {
				publicAvailability: null,
				candidates: "",
				section: "",
			},
			storefilterdata: {
				publicAvailability: null,
				candidates: "",
				section: "",
			},
			filtercount: 0,
			sort_selected: 4,
			sort_options: [
				{ text: "Test(Asc)", value: "1" },
				{ text: "Test(Desc)", value: "2" },
				{ text: "Date Created(Asc)", value: "3" },
				{ text: "Date Created(Desc) (Default)", value: "4" },
				{ text: "Date Modified(Asc)", value: "5" },
				{ text: "Date Modified(Desc)", value: "6" },
			],
			testTypeOptions: [
				{ text: "All", value: "2" },
				{ text: "Active", value: "1" },
				{ text: "Inactive", value: "0" },
			],

			Q_options: [
				{ text: "All", value: "ALL", disabled: false },
				{ text: "MCQ", value: "MCQU", disabled: false },
				{ text: "MTF", value: "MAFO", disabled: false },
				{ text: "Descriptive", value: "LONG", disabled: false },
			],
			options: [
				{
					item: true,
					name: "Yes",
				},
				{
					item: false,
					name: "No",
				},
			],
			answer: ["outline-dark"],
		};
	},
	components: {
		AutoSideTestConfiguration,

		Autotestgrid,
		Autotestcard,
		TestPreview,

		Spinner,
	},
	validations: {
		sectionData: {
			testName: {
				required,
				maxLength: maxLength(128),
				alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
			},
			noofSections: {
				required: requiredIf(function() {
					return this.sectionData.autoCheck;
				}),
				alpha: helpers.regex("alpha", /^\d+$/),

				between: between(1, 5),
			},
			autoQuestions: {
				required: requiredIf(function() {
					return this.sectionData.autoCheck;
				}),
				alpha: helpers.regex("alpha", /^\d+$/),

				between: between(1, 50),
			},
			questiontype_options: {
				required: requiredIf(function() {
					return this.sectionData.autoCheck;
				}),
			},
		},
		filter: {
			section: {
				between: between(0, 1000),
			},
		},
		name: {
			required,
			maxLength: maxLength(128),
		},
	},
	created() {
		this.LoaderStatus = true;

		this.$store.commit("searchVUEX/saveSearchTopicTest", "");
		this.tabRedirect();
	},
	watch: {
		selectedOptions: {
			handler(newVal) {
				// Update the selected options in sectionData when selectedOptions changes
				this.sectionData.questiontype_options = [...newVal];
			},
			deep: true,
		},
		searchTopicTest(newValue, oldValue) {
			if (newValue != oldValue) {
				this.resetPagination();
			}
		},
		testConfigData() {
			this.selectedTest = { ...this.testConfigData };
		},
		// Watch for these variables for Tab Redirect
		testCardselected() {
			this.$router.push({
				name: `AutogenerateTest`,
				query: {
					type: this.testCardselected,
					sort: this.sort_selected,
				},
			});
		},
		sort_selected() {
			this.$router.push({
				name: `AutogenerateTest`,
				query: {
					type: this.testCardselected,
					sort: this.sort_selected,
				},
			});
		},
	},
	computed: {
		cssForDynamicColor() {
			return {
				"--dynamicBorderColor":
					"#" +
					Math.random()
						.toString(16)
						.slice(-6),
			};
		},
		...mapGetters("autotestVUEX", {
			testConfigData: "getTestConfigData",
			testConfigStatus: "getTestConfigStatus",
			showTestPreviewStatus: "getShowTestPreviewStatus",
		}),
		...mapGetters("searchVUEX", {
			list: "getListView",
			grid: "getGridView",
			switchviews: "getToggleView",
			searchTopicTest: "getSearchTopicTest",
		}),
		...mapGetters(["roles"]),
		filtererdTopicDetails() {
			return this.autoTests.filter((data) => {
				return (
					!this.searchTopicTest ||
					data.name.toLowerCase().includes(this.searchTopicTest.toLowerCase())
				);
			});
		},
		isEmpty() {
			let temp;
			if (this.searchTopicTest == "") {
				temp = false;
			} else if (
				this.searchTopicTest != "" &&
				this.filtererdTopicDetails.length == 0
			) {
				temp = true;
			}
			if (
				this.filter.section != "" ||
				this.filter.candidates != "" ||
				this.filter.publicAvailability != null
			) {
				if (this.autoTests.length == 0) {
					temp = true;
				}
			}
			return temp;
		},
	},
	mounted() {
		const el = document.getElementById("top1");
		el.addEventListener("click", this.simple, false);
	},
	methods: {
		clearFields() {
			if (!this.sectionData.autoCheck) {
				this.sectionData.noofSections = null;
				this.sectionData.questiontype_options = [];
				this.sectionData.autoQuestions = null;
			}
		},
		hideFilterFunction() {
			this.showfiltercard = false;
		},
		hideSortFunction() {
			this.showsortcard = false;
		},
		hideTestFunction() {
			this.showtestcard = false;
		},
		resetPagination() {
			this.testState = [];
			this.page = 0;
			this.showLoader = false;
			this.LoaderStatus = true;
			this.getTests(true);
		},
		avoidLetterE(event) {
			const key = event.key;
			const maxLength = 3;
			const hasDecimal = this.filter.section.includes(".");

			if (
				key.toLowerCase() === "e" ||
				hasDecimal ||
				key === "." ||
				key === "-" ||
				this.filter.section.length >= maxLength
			) {
				event.preventDefault();
			}
		},
		...mapMutations("searchVUEX", {
			saveToggleView: "saveToggleView",
		}),
		// Managing tab redirect based on Test type and Sort
		tabRedirect() {
			if (this.$route.query.sort || this.$route.query.type) {
				this.sort_selected = this.$route.query.sort;
				this.testCardselected = this.$route.query.type;
				this.saveSort();
				return;
			}
			this.clearfilter();
		},
		closenewmodal() {
			this.$v.$reset();
			this.sectionData.testName = "";
			this.sectionData.noofSections = null;
			this.sectionData.questiontype_options = [];
			this.sectionData.autoQuestions = null;
			this.sectionData.autoCheck = false;
			this.$bvModal.hide("new-modal");
		},
		hideasnswertype() {
			this.isChecked = false;
		},

		lengthofTotalTestsWhenEdited(data, cloneData) {
			this.autoTests[data].name = cloneData.name;
			this.autoTests[data].publicAvailability = cloneData.publicAvailability;
		},

		updateOptions() {
			const mcqSelected = this.selectedOptions.includes("MCQU");
			const mtfSelected = this.selectedOptions.includes("MAFO");
			const descSelected = this.selectedOptions.includes("LONG");
			const allSelected = this.selectedOptions.includes("ALL");

			if (mcqSelected && mtfSelected && descSelected && allSelected) {
				// If all MCQ, MTF, and DESC are selected and "ALL" is selected, deselect them
				const mcqIndex = this.selectedOptions.indexOf("MCQU");
				if (mcqIndex !== -1) {
					this.selectedOptions.splice(mcqIndex, 1);
				}

				const mtfIndex = this.selectedOptions.indexOf("MAFO");
				if (mtfIndex !== -1) {
					this.selectedOptions.splice(mtfIndex, 1);
				}

				const descIndex = this.selectedOptions.indexOf("LONG");
				if (descIndex !== -1) {
					this.selectedOptions.splice(descIndex, 1);
				}
			} else if (mcqSelected || mtfSelected || descSelected) {
				// If any of MCQ, MTF, or DESC is selected, deselect "ALL"
				const index = this.selectedOptions.indexOf("ALL");
				if (index !== -1) {
					this.selectedOptions.splice(index, 1);
				}
			}
		},

		onScroll(e) {
			// Get the target element of the scroll event.
			const { target } = e;
			// Check if the user has reached the bottom of the scrollable area.
			if (
				Math.ceil(target.scrollTop) >=
				target.scrollHeight - target.offsetHeight
			) {
				// Check if there is more data to load.
				if (this.checkbetween(this.pageEnd, 0, this.total)) {
					this.page++;
					this.getTests(false);
				}
			}
		},
		checkbetween(x, min, max) {
			// Return `true` if `x` is between `min` and `max`, otherwise `false`.
			return x > min && x < max;
		},
		addAutoTest() {
			this.$bvModal.show("new-modal");
		},

		async getTests(flag) {
			try {
				const payload = this.buildPayload();
				const res = await getAutoGeneratedQusPagintion(payload);

				if (res.status === 200) {
					this.handleSuccessResponse(res, flag);
				} else {
					this.showAddNewCardWhenNoData = true;
				}
			} catch (error) {
				console.log(error);
			}
		},

		buildPayload() {
			const payload = {
				topicID: this.$route.query.topicID,
				searchQuery: this.searchTopicTest,
				sortBy: this.sortColumn,
				order: this.sortorder,
				publicAvailability: this.filter.publicAvailability,
				sections: this.filter.section,
				candidates: this.filter.candidates,
				type: this.activeForTest,
				page: this.page,
				count: this.count,
			};

			this.cleanPayload(payload);
			return payload;
		},

		cleanPayload(payload) {
			if (payload.sortBy == null) {
				delete payload.sortBy;
				delete payload.order;
			}
			if (payload.publicAvailability == null) {
				delete payload.publicAvailability;
			}
			if (payload.sections.toString().length === 0) {
				delete payload.sections;
			}
			if (payload.candidates.toString().length === 0) {
				delete payload.candidates;
			}
			if (payload.searchQuery === "") {
				delete payload.searchQuery;
			}
		},

		handleSuccessResponse(res, flag) {
			this.$store.commit("autotestVUEX/saveAutoTopicID", res.data.data.topicID);
			this.$store.commit("autotestVUEX/saveShowTestConfig", {
				config_data: {
					testID: "",
				},
				config_status: false,
			});
			this.$store.commit("autotestVUEX/saveshowPreviewTest", {
				preview_status: false,
			});

			if (res.data.data.data.length !== 0) {
				this.processTestData(res, flag);
			} else {
				this.autoTests = [];
				this.handleNoTestData(res);
			}

			if (this.LoaderStatus === true) {
				this.LoaderStatus = false;
			}
		},

		processTestData(res, flag) {
			if (this.page === 0) {
				this.autoTests = res.data.data.data.map((data) =>
					this.mapTestData(data, res.data.data.topicID)
				);
			} else {
				const data = res.data.data.data.map((data) =>
					this.mapTestData(data, res.data.data.topicID)
				);
				this.autoTests = [...this.autoTests, ...data];
			}

			this.showLoader = res.data.data.total !== res.data.data.pageEnd;
			this.total = res.data.data.total;
			this.pageEnd = res.data.data.pageEnd;

			if (flag) {
				this.selectedTest = this.autoTests[0];
			}

			this.showAddNewCardWhenNoData = res.data.data.total === 0;
		},

		mapTestData(data, topicID) {
			return { ...data, editoption: false, topicID };
		},

		handleNoTestData(res) {
			this.selectedTest = {};
			this.showAddNewCardWhenNoData = res.data.data.total === 0;
		},

		getTestValue(data) {
			this.showtestcard = false;
			this.activeForTest = data;
			this.resetPagination();
		},
		simple() {
			this.showtestcard = false;
			this.showfiltercard = false;
			this.showsortcard = false;
		},
		str_to_bool(s) {
			if (s == "True") {
				return true;
			} else if (s == "False") {
				return false;
			} else {
				return false;
			}
		},
		activate_card(i) {
			if (this.card_active != i) {
				this.card_active = i;
			}
		},
		goToAutoSec() {
			this.$v.$touch();
			if (!this.$v.sectionData.$invalid) {
				this.$store.commit("autotestVUEX/saveAutoGenData", this.sectionData);
				this.$router.push({
					name: "AutogenerateSection",
					query: {
						type: this.testCardselected,
						sort: this.sort_selected,
						available: this.publicAvailability,
					},
				});
			}
		},
		testcardoptions(data) {
			for (let i in this.autoTests) {
				this.autoTests[i].editoption = false;
				if (this.autoTests[i].testID == data) {
					this.autoTests[i].editoption = true;
				}
			}
		},
		saveSort() {
			if (this.sort_selected == "1") {
				this.sortColumn = "name";
				this.sortorder = 1;
			} else if (this.sort_selected == "2") {
				this.sortColumn = "name";
				this.sortorder = -1;
			} else if (this.sort_selected == "3") {
				this.sortColumn = "createdAt";
				this.sortorder = 1;
			} else if (this.sort_selected == "4") {
				this.sortColumn = "createdAt";
				this.sortorder = -1;
			} else if (this.sort_selected == "5") {
				this.sortColumn = "updatedAt";
				this.sortorder = 1;
			} else {
				this.sortColumn = "updatedAt";
				this.sortorder = -1;
			}

			if (this.testCardselected == "Active") {
				this.activeForTest = 1;
			} else if (this.testCardselected == "Inactive") {
				this.activeForTest = 0;
			} else {
				this.activeForTest = 2;
			}

			this.resetPagination();
			this.showsortcard = false;
		},
		applyfilter() {
			this.storefilterdata = { ...this.filter };
			this.filtercount = 0;
			if (this.filter.section.toString().length > 0) {
				this.filtercount++;
			}
			if (this.filter.candidates.toString().length > 0) {
				this.filtercount++;
			}
			if (this.filter.publicAvailability != null) {
				this.filtercount++;
			}
			this.resetPagination();
			this.showfiltercard = false;
			this.filterModelValue = false;
		},
		modalpop() {
			this.filter = { ...this.storefilterdata };
			this.showfiltercard = !this.showfiltercard;
			this.showsortcard = false;
			this.showtestcard = false;
		},
		clearfilterbox() {
			this.filter = {
				publicAvailability: null,
				candidates: "",
				section: "",
			};
			this.filterModelValue = false;

			this.showfiltercard = true;
			this.page = 0;

			this.showLoader = false;
			this.filtercount = 0;
		},
		clearfilter() {
			this.filter = {
				publicAvailability: null,
				candidates: "",
				section: "",
			};
			this.storefilterdata = {
				publicAvailability: null,
				candidates: "",
				section: "",
			};
			this.filterModelValue = false;
			this.filtercount = 0;
			this.showfiltercard = false;
			this.resetPagination();
		},
	},
};
</script>

<style>
#new-modal .modal-body {
	padding: 1rem;
}
.not-allowed {
	cursor: not-allowed;
}

.qb-disabled {
	color: #c4c4c4;
	border-color: #c4c4c4 !important;
}

.qb-disabled img {
	filter: invert(88%) sepia(3%) saturate(9%) hue-rotate(11deg) brightness(90%)
		contrast(90%);
}

.autest-parent
	.custom-checkbox.b-custom-control-sm
	.custom-control-label::before,
.input-group-sm .custom-checkbox .custom-control-label::before {
	top: 0.21875rem;
	left: -1.3125rem;
	width: 0.875rem;
	height: 0.875rem;
	border-radius: 0.2rem;
}
.disable-autofieldsetStyle {
	color: var(--bg-tertiary);
	background: #f4f4f4;

	position: absolute;
	left: 0.5vw;
	top: -9px;
	font-size: var(--size-10);
	line-height: 18px;
	z-index: 5;
	padding-left: 6px;
	padding-right: 4px;
}

.qb-dropdown-option-sing input:checked {
	background: red;
}

.agt-add-drop > .btn-secondary:nth-child(2n) {
	background: #fdfdfd;
	color: #545454;
	text-align: left;
	border: none;
}

.agt-add-drop > .btn-secondary:nth-child(2n-1) {
	background: #f4f4f4;
	color: #545454;
	text-align: left;
	border: none;
}
</style>
<style scoped>
.z-10 {
	z-index: 10;
}

.tnt-sortcard .custom-control {
	padding-left: 2rem !important;
	padding-top: 5px;
	padding-bottom: 5px;
}

.sort-radio:nth-child(even) {
	background: #fdfdfd;
}

.sort-radio:nth-child(odd) {
	background: #f4f4f4;
}

.auto-sortcontainer {
	position: relative;
	background: #fcfcfc;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border: 1px solid #72738e;
	border-radius: 3px;
	padding: 5px 10px;
}

.jdtyperadio:nth-child(odd) {
	background: #f4f4f4;
}

.jdtyperadio:nth-child(even) {
	background: #fdfdfd;
}

.sorttext {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
}

.sortline {
	width: 0px;
	height: 19px;
	border: 1px solid #c4c4c4;
	background: #c4c4c4;
}

.sortordertext {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
}

.flip-list-move {
	transition: transform 1s;
}

.cell:nth-child(3n) {
	margin-right: 0;
}

.cell:nth-child(27n) {
	margin-bottom: 0;
}

.cell-move {
	transition: transform 1s;
}

.sort-box {
	border: 1px solid #72738e;
	padding: 5px 8px;

	border-radius: 3px;
}

.filter-box {
	border: 1px solid #72738e;
	padding: 5px;

	border-radius: 3px;
}

.heading-container {
	position: relative;
	z-index: 1;
}

.heading-container::before {
	content: "";
	display: inline-block;
	position: absolute;
	width: 27px;
	height: 20px;
	top: 3px;
	left: -11px;
	z-index: -1;
	background: var(--cv-yellow);
	-moz-border-radius: 10px;
	-webkit-border-radius: 10px;
	border-radius: 50%;
}

.boxtext {
	font-weight: var(--weight-M);
	font-size: var(--size-18);

	color: var(--headtext) !important;
}

.test-container {
	width: 215px;
}

.qb-filter-count {
	width: 18px;
	background: #ff7e47;
	border-radius: 10px;
	height: 19px;
	font-weight: var(--weight-B);
	font-size: var(--size-10);
	padding-top: 2px;
	padding-left: 7px;
	position: absolute;
	top: -5px;
	right: -15px;
}

.ags-dropdown-diffy:focus {
	border: 1px solid rgba(10, 86, 200, 0.5);
}

.ags-dropdown-diffy:hover {
	border: 1px solid rgba(10, 86, 200, 0.5);
}

.ags-dropdown-diffy:active {
	border: 1px solid rgba(10, 86, 200, 0.5);
}

.ags-dropdown-diffy {
	background: #ffffff;
	border: 0.7px solid rgba(10, 86, 200, 0.5);
	box-sizing: border-box;
	border-radius: 3px;
	color: #959494;
	font-size: var(--size-13);
	padding: 8px;
}

.ags-inactive {
	color: #adaaaa;

	background-color: #b8b8b8;
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	border-radius: 3px;
	font-size: var(--size-13);
	padding: 8px;
	opacity: 0.8;
}

.topDiv > .ags-inactive-inputField {
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	border-radius: 3px !important;
	font-size: var(--size-12);
	font-weight: var(--weight-LM);
	line-height: 18px;
	z-index: 5;
	padding: 18px 8px;
	color: #000000;
	background-color: #b8b8b8;

	opacity: 0.8;
}

.qb-dropdown-option-sing:nth-child(even) {
	background: #fdfdfd;

	padding: 10px 10px;
}

.qb-dropdown-option-sing:nth-child(odd) {
	background: #f4f4f4;

	padding: 10px 10px;
}
</style>
